const GetDefinition = (field) => {
    switch (field.field_type) {
        case 'alnum':
        case 'phone':
        case 'email':
        case 'string':
            return {
                label          : field.name,
                type           : "text",
                fieldSettings  : {min: 0},
                valueSources   : ["value"],
                mainWidgetProps: {
                    valueLabel      : field.name,
                    valuePlaceholder: `Enter ${field.name}`,
                },
                operators: ['equal', 'not_equal', 'is_empty', 'is_not_empty']
            }
        case 'numeric':
            return {
                label          : field.name,
                type           : "number",
                fieldSettings  : {min: 0},
                valueSources   : ["value"],
                mainWidgetProps: {
                    valueLabel      : field.name,
                    valuePlaceholder: `Enter ${field.name}`,
                },
                preferWidgets  : ["number"],
                operators: [
                    'equal', 'not_equal', 'greater', 'greater_or_equal', 'less', 'less_or_equal',
                    'between', 'not_between', 'is_empty', 'is_not_empty'
                ]
            }

        case 'date':
        case 'datetime':
            return {
                label          : field.name,
                type           : "datetime",
                preferWidgets  : ["datetime"],
                valueSources   : ["value"],
                mainWidgetProps: {
                    valueLabel      : field.name,
                    valuePlaceholder: `Enter ${field.name}`,
                },
                operators: [
                    'equal', 'not_equal', 'greater', 'greater_or_equal', 'less', 'less_or_equal',
                    'between'
                ]
            }

        case 'list_item':
            return {
                label        : field.name,
                valueSources : ["value"],
                operators    : ['multiselect_contains'],
                type         : "multiselect",
                fieldSettings: {
                    allowCustomValues: true
                },
                mainWidgetProps: {
                    valueLabel      : field.name,
                    valuePlaceholder: `Enter ${field.name}`,
                },
            }

        default:
            return {
                label          : field.name,
                type           : "text",
                valueSources   : ["value"],
                fieldSettings  : {min: 0},
                mainWidgetProps: {
                    valueLabel      : field.name,
                    valuePlaceholder: `Enter ${field.name}`,
                },
                operators: ['equal', 'not_equal', 'is_empty', 'is_not_empty']
            }
    }


}

export {GetDefinition};